module.exports = __webpack_public_path__ + "static/img/9.147c4a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shop/product/9.jpg
// module id = sYa8
// module chunks = 1